import server from './http'
import loginApi from './login'
import homeApi from './home'
import employmentApi from './employment'
import configCenterAPI from './configCenter'
import scheduleApi from './schedule'
import contract from './contract'

// ===== 公共 API =====
const PublicAPI = {
  login: (param) => server.post('/public/login', param),
  getUserInfo: (param) => server.post('/public/getUserInfo', param),
  uploadImage: (param) => server.post('/public/uploadImage', param),
  validationBusinessLicense: (param) => server.post('/public/validationBusinessLicense', param),
  companyVerification: (param) => server.post('/public/companyVerification', param),
  customerVerification: (param) => server.post('/public/customerVerification', param),
  identityVerification: (param) => server.post('/public/identityVerification', param), // 实名认证
  getDictInfo: (param) => server.post('/public/dictTypeInfo', param),
  getPointByAddress: (param) => server.post('/public/getPointByAddress', param),
  getAllRegion: (param) => server.post('/public/getAllRegion', param),    // 获取省市区
  refreshAccessToken: (param) => server.post('/public/refreshAccessToken', param),  // 刷新访问令牌
  getProfile: (param) => server.post('/public/getProfile', param),  // 获取用户信息
  saveCompanyInfo: (param) => server.post('/public/saveCompanyInfo', param),  // 保存企业开票信息
  completeGuide: (param) => server.post('/public/completeGuide', param),
  getCompanyInfo: (param) => server.post('/public/getCompanyInfo', param),  // 获取企业认证信息
  switchCompany: (param) => server.post('/public/switchCompany', param),  // 切换公司
  aiAgent: (param) => server.post('/portal/aiAgent', param),
}

// ===== 首页 API =====
const HomeAPI = {
  getWorkData: (param) => server.post('/admin/Home/workData', param),
  getOrderCenter: (param) => server.post('/admin/Home/orderCenter', param),
  getPersonnelList: (param) => server.post('/admin/Home/personnelList', param),
}

// ===== 工作台 API =====
const WorkbenchAPI = {
  getDashboard: (param) => server.post('/admin/Workbench/dashboard', param),
  getTaskList: (param) => server.post('/admin/Workbench/taskList', param),
  getSchedule: (param) => server.post('/admin/Workbench/schedule', param),
  getAllTaskListBySceneWork: (param) => server.post('/workbench/getAllTaskListBySceneWork', param),   // 获取任务列表
  getSceneWorkTree: (param) => server.post('/workbench/getSceneWorkTree', param),  // 获取行业岗位联动
  getInviteCode: (param) => server.post('/workbench/getInviteCode', param),  // 项目邀请二维码
}

// ===== 用工管理 API =====
const EmploymentAPI = {
  getManageList: (param) => server.post('/admin/Employment/manageList', param),
  getRecruitmentList: (param) => server.post('/admin/Employment/recruitmentList', param),
  getContractList: (param) => server.post('/admin/Employment/contractList', param),
  getAttendanceList: (param) => server.post('/admin/Employment/attendanceList', param),
}

// ===== 消息中心 API =====
const MessageAPI = {
  getMessageList: (param) => server.post('/notice/messageList', param), // 消息列表
  setRead: (param) => server.post('/notice/setRead', param), // 设置已读
  getStatistics: (param) => server.post('/notice/statistics', param), // 消息角标
  getNotificationList: (param) => server.post('/admin/Message/notification', param),
  getAnnouncementList: (param) => server.post('/admin/Message/announcement', param),
}

// ===== 风控中心 API =====
const RiskAPI = {
  getControlList: (param) => server.post('/admin/Risk/controlList', param),
  getWarningList: (param) => server.post('/admin/Risk/warningList', param),
  getAuditList: (param) => server.post('/admin/Risk/auditList', param),
}

// ===== 配置中心 API =====
const ConfigAPI = {
  getBasicConfig: (param) => server.post('/admin/Config/basic', param),
  getPermissionList: (param) => server.post('/admin/Config/permission', param),
  getSystemConfig: (param) => server.post('/admin/Config/system', param),
  getBgdMoneyCharge: (param) => server.post('/configure/getBgdMoneyCharge', param),    // 百工得钱包
  getYjtMoneyCharge: (param) => server.post('/configure/getYjtMoneyCharge', param),    // 易匠通钱包
  getBgdTradeRecords: (param) => server.post('/configure/getBgdTradeRecords', param),  // 百工得交易记录
  getYjtTradeRecords: (param) => server.post('/configure/getYjtTradeRecords', param),  // 易匠通交易记录
  getYjtRechargeRecords: (param) => server.post('/configure/getYjtRechargeRecords', param), // 易匠通充值记录
  getYjtRefundRecords: (param) => server.post('/configure/getYjtRefundRecords', param),     // 易匠通退款记录
  getBgdRechargeRecords: (param) => server.post('/configure/getBgdRechargeRecords', param), // 百工得充值记录
  getYjtAvailableRefundAccountList: (param) => server.post('/configure/getYjtAvailableRefundAccountList', param), // 易匠通可退款账号
  yjtApplyRefund: (param) => server.post('/configure/yjtApplyRefund', param),           // 易匠通申请退款
  getSuperVipInfo: (param) => server.post ('/portal/superVipInfo', param),             // 权益卡开票信息
  superVipInvoiceApply: (param) => server.post('/portal/superVipInvoiceApply', param), // 申请权益卡开票
}

// ===== 制单 API =====
const AgentAPI = {
  workbenchSubmitReward: (param) => server.post('/workbench/submitReward', param),  // 提交制单
  getServiceProviderConfigStatus: (param) => server.post('/workbench/getServiceProviderConfigStatus', param),
  getStaffFinanceConfigStatus: (param) => server.post('/workbench/getStaffFinanceConfigStatus', param),
  submitStaffBatch: (param) => server.post('/workbench/submitStaffBatch', param),  // 自有员工-制单
  downloadWagesTemplate: (param) => server.get('/workbench/downloadWagesTemplate', param, { responseType: 'blob' }),  // 自有员工-导出模版
  downloadOwnEmployeeComplianceTemplate: (param) => server.post('/manage/downloadTempFiles', param, { responseType: 'blob' }),  // 自有员工-合规资料模版
  importWagesTemplate: (param) => server.post('/workbench/importWagesTemplate', param),  // 自有员工-导入工资表
  getStaffBatchDraft: (param) => server.post('/workbench/getStaffBatchDraft', param),  // 自有员工-获取制单草稿
  getWagesDetail: (param) => server.post('/workbench/wagesDetail', param),  // 自有员工-订单详情
  batchWageDetail: (param) => server.post('/workbench/batchWageDetail', param),
  batchRewardDetail: (param) => server.post('/manage/hrms/batchRewardDetail', param),
  getPlatformServiceCooperationAgreement: (param) => server.post('/workbench/getPlatformServiceCooperationAgreement', param),  // 获取平台服务合作协议
  AgentCheckProfile: (param) => server.post('/workbench/checkProfile', param),  // 四要素验证
  calculateRound: (param) => server.post('/workbench/calculateRound', param),  // 计算取整
  AgentMakeReward: (param) => server.post('/workbench/makeReward', param),  // 制单信息
  importWorkbenchMembers: (param) => server.post('/workbench/importMembers', param),  // 制单人员导入
  getContractMembers: (param) => server.post('/workbench/getContractMembers', param),  // 获取私域成员
  saveTaskContractList: (param) => server.post('/workbench/saveTaskContractList', param),  // 保存任务订单
  changeFlexToInvoiceFirst: (param) => server.post('/workbench/changeToInvoiceFirst', param),  // 灵工、商户设置订单为提前开票
  sendSecurePaymentSms: (param) => server.post('/workbench/sendSecurePaymentSms', param),  // 发送安全支付短信
  submitPayment: (param) => server.post('/workbench/submitPayment', param),  // 提交支付
  submitStaffPayment: (param) => server.post('/workbench/submitStaffPayment', param),  // 自有员工提交支付
  batchSubmitStaffPayment: (param) => server.post('/workbench/batchSubmitStaffPayment', param),
  batchSubmitPayment: (param) => server.post('/workbench/batchSubmitPayment', param),
  staffDistributeGatewayList: (param) => server.post('/workbench/staffDistributeGatewayList', param),  // 自有员工支付渠道
  downloadProof: (param) => server.post('/workbench/downloadProof', param),  // 下载履约确认函
  updBatchMaterials: (param) => server.post('/workbench/updBatchMaterials', param),  // 更新订单材料
  getWorkBenchPaymentDetail: (param) => server.post('/workbench/workBenchPaymentDetail', param),  // 灵工-获取制单详情
  AgentProjectGetDetailView: (param) => server.post('/invoice/getDetailView', param),  // 工作台-获取任务综合视图
  getWorkBenchBatchChildList: (param) => server.post('/workbench/getWorkBenchBatchChildList', param),  // 灵工-获取制单列表
  getWorkBenchContractMemberListByTask: (param) => server.post('/invoice/getWorkBenchContractMemberListByTask', param),  // 灵工-获取任务接单人员
  rewardSubmitReward: (param) => server.post('/workbench/rewardSubmitReward', param),  // 灵工-灵工修改订单
  deleteWorkBenchBatchChild: (param) => server.post('/workbench/delTaskContract', param),  // 灵工-删除制单
  getTaskContractList: (param) => server.post('/workbench/getTaskContractList', param),  // 获取任务结算列表
  validatePersonRiskAnalysis: (param) => server.post('/workbench/validatePersonRiskAnalysis', param),  // 分析、计算个人风险、限额及个税数据
  getMerchantWorkBenchPaymentDetail: (param) => server.post('/workbench/merchantWorkBenchPaymentDetail', param),  // 商家-获取制单详情
  getMerchantWorkBenchBatchChildList: (param) => server.post('/workbench/getMerchantWorkBenchBatchChildList', param),  // 商家-获取制单列表
  personalSubmitReward: (param) => server.post('/workbench/personalSubmitReward', param),  // 商家-合作商修改订单
  getDistributeChannel: (param) => server.post('/manage/Hrms/getDistributeChannel', param),  // 获取支付通道
  buildPayslipsOrderList: (param) => server.post('/manage/hrms/saveReward', param),  // 制做工资单
  downloadPayslipsOrderTemp: (param) => server.get('/manage/hrms/downloadTempFiles', param, { responseType: 'blob' }),  // 下载模板
  ImportPayslipsOrderList: (param) => server.post('/manage/hrms/importSettleMember', param),  // 导入工资单
  getOnboardMemberList: (param) => server.post('/manage/hrms/getOnboardMemberList', param),  // 获取在职人员
  rewardRowCheck: (param) => server.post('/manage/hrms/rewardRowCheck', param),  // 结算单行验证
  allTableCheck: (param) => server.post('/manage/hrms/allTableCheck', param),  // 结算全部验证
  getSaveRewardInfo: (param) => server.post('/manage/hrms/getSaveRewardInfo', param),  // 获取人力制单信息
  getRewardDetail: (param) => server.post('/manage/hrms/rewardDetail', param),  // 订单详情-人力
  downloadBatchTablePdf: (param) => server.post('/manage/hrms/downloadBatchTablePdf', param),  // 下载结算单
  getInvoiceMakeDetail: (param) => server.post('/invoice/makeDetail', param),  // 灵工-获取开票详情
  getHrmsMakeDetail: (param) => server.post('/manage/hrms/hrmsMakeDetail', param),  // 人力-获取开票详情
  getViewProof: (param) => server.post('/invoice/getViewProof', param),  // 查看履约确认函/报酬明细（灵工、商户类型）
  getInvoiceAgreementList: (param) => server.post('/invoice/agreementList', param),  // 获取服务者协议列表
  viewInvoiceAgreement: (param) => server.post('/invoice/viewAgreement', param),  // 预览服务者协议
  getOutcomeProof: (param) => server.post('/invoice/getOutcomeProof', param),  // 查看工作场景（灵工）
  uploadInvoice: (param) => server.post('/invoice/upload', param),  // 灵工-上传发票
  editInvoiceItem: (param) => server.post('/invoice/editItem', param),  // 灵工-编辑发票
  cancelInvoice: (param) => server.post('/invoice/cancel', param),  // 灵工-发票红冲
  rebuildInvoice: (param) => server.post('/invoice/reBuild', param),  // 灵工-补开发票
  getInvoiceSettleApplyInfo: (param) => server.post('/invoice/getSettleApplyInfo', param),  // 获取园区开票申请信息
  addInvoiceSettle: (param) => server.post('/invoice/addInvoiceSettle', param),  // 申请园区发票
  rebuildInvoiceSettle: (param) => server.post('/invoice/reBuildInvoiceSettle', param),  // 补开园区发票
  scanInvoice: (param) => server.post('/public/invScan', param),  // 发票识别
  sureReward: (param) => server.post('/manage/hrms/sureReward', param),  // 确认订单-人力
  getInvoiceInfo: (param) => server.post('/manage/hrms/getInvoiceInfo', param),  // 人力订单-获取开票信息
  AgentgetViewInvoice: (param) => server.post('/manage/hrms/getViewInvoice', param).then(res => ({ data: res })),  // 人力订单-发票预览
  applyInvoice: (param) => server.post('/manage/hrms/invoiceApply', param),  //人力资源- 申请发票
  flexApplyInvoice: (param) => server.post('/workbench/applyInvoice', param),  //灵活用工- 申请发票
  changeToInvoiceFirst: (param) => server.post('/manage/hrms/changeToInvoiceFirst', param), // 人力订单-提前开票
  AgentgetViewInvoiceFirst: (param) => server.post('/manage/hrms/getViewInvoiceFirst', param).then(res => ({ data: res })),  // 人力订单-提前开票发票预览
  getViewProofTask: (param) => server.post('/workbench/getViewProofTask', param),  // 获取履约确认函
  downloadProofTask: (param) => server.post('/workbench/downloadProofTask', param),  // 下载履约确认函
  getPersonalViewProofTask: (param) => server.post('/workbench/getPersonalViewProofTask', param),  // 获取商户预览附件（履约确认函、劳务报酬明细表）
  personalDownloadProofTask: (param) => server.post('/workbench/personalDownloadProofTask', param),  // 下载商户附件（履约确认函、劳务报酬明细表）
}

export default {
  ...PublicAPI,
  ...HomeAPI,
  ...WorkbenchAPI,
  ...EmploymentAPI,
  ...MessageAPI,
  ...RiskAPI,
  ...ConfigAPI,
  ...AgentAPI,
  ...loginApi,
  ...homeApi,
  ...employmentApi,
  ...configCenterAPI,
  ...scheduleApi,
  ...contract
}
